import { FunctionFactory } from 'survey-core';
import { Gender } from '../quiz/gender';
import { getMotivationalByName } from './testimonials';
import { BodyType } from '../quiz/bodytype';
import { Physiology } from '../quiz/physiology';
import { getGenderKey } from '../features/utils';
import { locHtml } from './locHtml';
import { makeSplashHeader } from './SplashHeader';

const dissatisfactionSplashHtml = locHtml((t) => `
<div class="new-quote-container">
  <div class="splash-header">
    <h1>${t("splash.dissatisfaction.title")}</h1>
    <div class="quote">
      ${t("splash.dissatisfaction.text")}
    </div>
  </div>
  <div class="quote-img-container">
    <img src="{dissatisfactionImageUrl}" alt="${t("splash.testimonialAlt")}" />
  </div>
  <div class="image-footnote">{dissatisfactionTestimonialDisplayName} – ${t("splash.realMember")}</div>
</div>`);

const dissatisfactionImageUrlMap = {
  [BodyType.SkinnyFat]: {
    [Gender.Male]: getMotivationalByName('Reinis'),
    [Gender.Female]: getMotivationalByName('Salma'),
  },
  [BodyType.Skinny]: {
    [Gender.Male]: getMotivationalByName('Brian'),
    [Gender.Female]: getMotivationalByName('Salma'),
  },
  // todo: add correct motivational for this
  [BodyType.Defined]: {
    [Gender.Male]: getMotivationalByName('Adam'),
    [Gender.Female]: getMotivationalByName('Jade'),
  },
  // todo: add correct motivational for this
  [BodyType.Athletic]: {
    [Gender.Male]: getMotivationalByName('Adam'),
    [Gender.Female]: getMotivationalByName('Jade'),
  },
  [BodyType.Overweight]: {
    [Gender.Male]: getMotivationalByName('Adam'),
    [Gender.Female]: getMotivationalByName('Jade'),
  },
  [BodyType.Bulky]: {
    [Gender.Male]: getMotivationalByName('Adam'),
    [Gender.Female]: getMotivationalByName('Jade'),
  }
} as const;

const dissatisfactionImageUrlExpression = {
  name: "dissatisfactionImageUrl",
  expression: "renderDissatisfactionImageUrl({bodyType}, {gender}, {physiology})",
};

function renderDissatisfactionImageUrl(params: any[]): string {
  if (params === undefined || params === null) return "";
  const bodyType = params[0] as BodyType;
  const gender = params[1] as Gender;
  const physiology = params[2] as Physiology;
  const genderKey = getGenderKey(gender, physiology);

  return dissatisfactionImageUrlMap[bodyType]?.[genderKey].image ?? '';
}

FunctionFactory.Instance.register("renderDissatisfactionImageUrl", renderDissatisfactionImageUrl);

const dissatisfactionTestimonialDisplayNameExpression = {
  name: "dissatisfactionTestimonialDisplayName",
  expression: "renderDissatisfactionTestimonialDisplayName({bodyType}, {gender}, {physiology})",
};

function renderDissatisfactionTestimonialDisplayName(params: any[]): string {
  if (params === undefined || params === null) return "";
  const bodyType = params[0] as BodyType;
  const gender = params[1] as Gender;
  const physiology = params[2] as Physiology;
  const genderKey = getGenderKey(gender, physiology);

  return dissatisfactionImageUrlMap[bodyType]?.[genderKey].displayName ?? '';
}

FunctionFactory.Instance.register("renderDissatisfactionTestimonialDisplayName", renderDissatisfactionTestimonialDisplayName);

const dissatisfactionSplashElement = {
  visibleIf: `{dissatisfaction} > 2`,
  name: 'dissatisfaction-splash',
  type: 'html',
  html: dissatisfactionSplashHtml,
};

const DissatisfactionSplashHeader = makeSplashHeader("splash.headers.dissatisfaction");

export {
  dissatisfactionSplashElement,
  dissatisfactionImageUrlExpression,
  dissatisfactionTestimonialDisplayNameExpression,
  DissatisfactionSplashHeader,
}
